import { useEffect, useRef, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Home from './components/Home/Home';
// import Navbar from './components/Navbar/Navbar';
import Main from './Main';
import Bats from './assets/vectors/bats.svg'
import Ball from './assets/vectors/baloon.svg'
import Project from './components/Projects/Project';
import About from './components/About/About';
import Contact from './components/Contact/Contact';

const router = createBrowserRouter([
  { 
    path: '/', 
    element: <Main/>, 
    children: [
    {
      path: '/',
      index: true,
      element: <Home/>

    },
    {
      path: 'projects',
      element: <Project/>
    },
    {
      path: 'about',
      element: <About/>
    },
    {
      path: 'contact',
      element: <Contact/>
    }
  ] },
]);


function App() {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)
  const ball = useRef(null)

  useEffect(() => {
    fetch("https://api.github.com/users/ahmedsameh74")
      .then((response) => response.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      });

  }, [])

  // useEffect(() => {
  //   window.onscroll = () => {
  //     console.log(ball.current)
  //     window.scrollY > 0
  //       ? ball.current.classList.add("ballMove")
  //       : ball.current.classList.remove("ballMove");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [window.scrollY])

  return (
    <div className="App">
    
      {/* <Navbar/> */}
      {/* <div className="container"> */}
      {/* <Routes>
        <Route exact path="/"  element={<Home/>}/>
      </Routes> */}
      {loading && <div className='loading'>
        <img src={Bats} alt='loading'/>
      </div>}
      {!loading && <>
      <img src={Ball} alt='vector' className='ball' ref={ball} />
      <RouterProvider router={router}/>
      </>}
      {/* </div> */}
    </div>
  );
}

export default App;
